import { render } from "./ComplianceSingleClaimComponent.vue?vue&type=template&id=f82ec088&scoped=true"
import script from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceSingleClaimComponent.vue?vue&type=script&lang=js"

import "./ComplianceSingleClaimComponent.vue?vue&type=style&index=0&id=f82ec088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f82ec088"]])

export default __exports__